import React from 'react';
import type { VideoFormat } from '@hyvay/video-engine';
import { STUDIO_FONT_MONO as FONT_MONO } from '../landing/landingData';

export const FORMAT_OPTIONS: { value: VideoFormat; label: string; hint: string }[] = [
    { value: 'landscape', label: '16:9', hint: 'YouTube, layar booth' },
    { value: 'portrait', label: '9:16', hint: 'Reels, TikTok, Story' },
    { value: 'square', label: '1:1', hint: 'Feed Instagram' },
];

export const SCENE_LABEL: Record<string, string> = {
    title: 'Pembuka', statement: 'Kalimat', screenshot: 'Screenshot', image: 'Foto',
    features: 'Keunggulan', stat: 'Angka', quote: 'Testimoni', video: 'Klip video', cta: 'Ajakan',
};

export const STATUS_LABEL: Record<string, string> = {
    QUEUED: 'Antre', RENDERING: 'Merender', DONE: 'Selesai', FAILED: 'Gagal',
};

export const BetaChip: React.FC = () => (
    <span style={{ fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: '0.16em', padding: '3px 8px', borderRadius: 999, background: 'var(--hv-sand)', color: 'var(--hv-sand-ink)' }}>BETA</span>
);

/** Segmented control in the studio's pill style. */
export function Segmented<T extends string>({ value, options, onChange }: { value: T; options: { value: T; label: string; hint?: string }[]; onChange: (v: T) => void }) {
    return (
        <div style={{ display: 'inline-flex', padding: 3, borderRadius: 999, background: 'var(--hv-page-2)', border: '1px solid var(--hv-line)' }}>
            {options.map((o) => (
                <button
                    key={o.value}
                    type="button"
                    title={o.hint}
                    onClick={() => onChange(o.value)}
                    style={{ height: 30, padding: '0 13px', borderRadius: 999, border: 0, cursor: 'pointer', fontSize: 12.5, fontWeight: 700, background: value === o.value ? 'var(--hv-card)' : 'transparent', color: value === o.value ? 'var(--hv-ink)' : 'var(--hv-muted)', boxShadow: value === o.value ? '0 4px 10px -6px var(--hv-shadow)' : 'none' }}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
}

export const fieldLabel: React.CSSProperties = { fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--hv-muted)', marginBottom: 7 };
export const input: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '9px 11px', borderRadius: 10, border: '1px solid var(--hv-line)', background: 'var(--hv-card)', color: 'var(--hv-ink)', fontSize: 13.5, fontFamily: 'inherit', outline: 'none' };

/**
 * Keeps a crash inside the video pages from leaving a blank white screen: shows
 * the error (so it can be reported) and a reload button. Reset on route change
 * via `key`.
 */
export class VideoErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
    state = { error: null as Error | null };

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('[video] render crash', error, info.componentStack);
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#E9E9E3', fontFamily: 'system-ui, sans-serif', color: '#0E2A1C', padding: 24 }}>
                <div style={{ maxWidth: 560 }}>
                    <div style={{ fontSize: 22, fontWeight: 700 }}>Halaman video mengalami error</div>
                    <pre style={{ marginTop: 12, padding: 12, borderRadius: 10, background: '#fff', border: '1px solid #E4E3DC', fontSize: 12.5, whiteSpace: 'pre-wrap', color: '#B4483E' }}>{this.state.error.message}</pre>
                    <button type="button" onClick={() => window.location.reload()} style={{ marginTop: 12, height: 40, padding: '0 18px', borderRadius: 999, border: 0, background: '#13422C', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Muat ulang</button>
                </div>
            </div>
        );
    }
}
